export const GRAVITY_FALL = 2700;
export const GRAVITY_HELD = 1230;
export const WALK_MAX = 135;
export const RUN_MAX = 237;
export const WALK_ACCEL = 360;
export const RUN_ACCEL = 510;
export const SKID_DECEL = 780;
export const FRICTION = 465;
export const AIR_ACCEL = 270;
// Apex with GRAVITY_HELD: walking ~110px (4.6 tiles, lands on the 4-high block
// rows), running ~141px (5.9 tiles), matching the 1985 jump arcs.
export const JUMP_WALK = -520;
export const JUMP_RUN = -590;
export const JUMP_CUT = 0.45;
export const STOMP_BOUNCE = -252;
export const STOMP_HELD = -372;
export const STOMP_VY_MIN = 60;
export const STOMP_SLOP = 15;
export const WALKER_SPEED = 48;
export const TROOPA_SPEED = 42;
export const SHELL_SPEED = 270;
export const FIREBALL_SPEED = 330;
export const FIREBALL_BOUNCE = -180;
export const MAX_FIREBALLS = 2;
export const INVULN_MS = 1800;
export const STAR_MS = 8000;
export const TIMER_TICK_MS = 400;
export const DEATH_JUMP = -420;
export const WORLD_LEFT_PAD = 12;
export const COYOTE_MS = 140;
export const JUMP_BUFFER_MS = 160;

export function maxSpeed(running: boolean): number {
  return running ? RUN_MAX : WALK_MAX;
}

export function jumpVelocity(speed: number): number {
  return Math.abs(speed) > WALK_MAX * 0.85 ? JUMP_RUN : JUMP_WALK;
}

export function stompBounce(jumpHeld: boolean): number {
  return jumpHeld ? STOMP_HELD : STOMP_BOUNCE;
}

export function isStomp(playerBottom: number, playerVy: number, enemyTop: number): boolean {
  return playerVy >= STOMP_VY_MIN && playerBottom <= enemyTop + STOMP_SLOP;
}

export function applyGroundAccel(
  vx: number,
  input: number,
  running: boolean,
  dt: number,
): { vx: number; skidding: boolean } {
  if (input === 0) {
    const next = vx - Math.sign(vx) * FRICTION * dt;
    return { vx: Math.sign(vx) !== Math.sign(next) ? 0 : next, skidding: false };
  }

  const cap = maxSpeed(running);
  const against = Math.sign(vx) !== 0 && Math.sign(vx) !== input;
  const accel = against ? SKID_DECEL : running ? RUN_ACCEL : WALK_ACCEL;
  let next = vx + input * accel * dt;
  if (against && Math.sign(next) !== Math.sign(vx)) {
    next = input * 12;
  }
  next = PhaserMathClamp(next, -cap, cap);
  return { vx: next, skidding: against && Math.abs(vx) > 40 };
}

export function applyAirAccel(vx: number, input: number, running: boolean, dt: number): number {
  if (input === 0) return vx;
  const cap = maxSpeed(running);
  const next = vx + input * AIR_ACCEL * dt;
  return PhaserMathClamp(next, -cap, cap);
}

function PhaserMathClamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export { PhaserMathClamp as clamp };
